import React from 'react';
import PropTypes from 'prop-types';

export const IconCards = ({ className }) => (
  <svg className={className} width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.0566406 19.8C0.0566406 20.4627 0.593899 21 1.25664 21C1.91938 21 2.45664 20.4627 2.45664 19.8L2.45664 8.2C2.45664 7.53726 1.91938 7 1.25664 7C0.5939 7 0.0566406 7.53726 0.0566406 8.2V19.8Z" fill="#C29F6C" />
    <path d="M4.59688 23C3.93414 23 3.39688 22.4627 3.39688 21.8L3.39688 6.2C3.39688 5.53726 3.93414 5 4.59688 5C5.25962 5 5.79688 5.53726 5.79688 6.2L5.79688 21.8C5.79688 22.4627 5.25962 23 4.59688 23Z" fill="#C29F6C" />
    <path fillRule="evenodd" clipRule="evenodd" d="M7.2053 21C7.2053 23.2091 8.99616 25 11.2053 25H21.5441C23.7532 25 25.5441 23.2091 25.5441 21V7C25.5441 4.79086 23.7532 3 21.5441 3H11.2053C8.99616 3 7.2053 4.79086 7.2053 7V21ZM9.6053 7V21C9.6053 21.8837 10.3216 22.6 11.2053 22.6H21.5441C22.4278 22.6 23.1441 21.8837 23.1441 21V7C23.1441 6.11634 22.4278 5.4 21.5441 5.4H11.2053C10.3216 5.4 9.6053 6.11634 9.6053 7Z" fill="#C29F6C" />
  </svg>

);

IconCards.propTypes = {
  className: PropTypes.string,
};
IconCards.defaultProps = {
  className: '',
};
